import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { CommonErrorModal } from './CommonErrorModal.tsx';

const i18n = defineMessages({
	title: {
		id: 'import-from-sources.markdown.outcome-unknown.title',
		defaultMessage: 'Check whether your page was created',
		description:
			'Title shown when a Markdown create request may have completed after connection loss',
	},
	body: {
		id: 'import-from-sources.markdown.outcome-unknown.body',
		defaultMessage:
			'We lost the connection after starting page creation. Check the destination page tree before importing again. Support reference: {attemptId}',
		description:
			'Guidance shown when Confluence cannot tell whether a Markdown page was created; includes an opaque support reference',
	},
	close: {
		id: 'import-from-sources.markdown.outcome-unknown.close',
		defaultMessage: 'Close',
		description: 'Closes the unknown Markdown import outcome dialog',
	},
});

export const OutcomeUnknownModal = ({
	attemptId,
	onClose,
}: {
	attemptId: string;
	onClose: () => void;
}): React.JSX.Element => (
	<CommonErrorModal
		onClose={onClose}
		onSubmit={onClose}
		headText={<FormattedMessage {...i18n.title} />}
		bodyText={<FormattedMessage {...i18n.body} values={{ attemptId }} />}
		submitText={<FormattedMessage {...i18n.close} />}
		hideCloseAction
		suppressSubmitAnalytics
	/>
);
